<template>
  <div class="revive-splash-page">
    <div class="lcu-splash-logo">
      <SpinLoader :color="'white'" :size="'200px'" />
      <img class="lcu-splash-loader" src="/assets/LCU-logo-white-loader.svg" />
    </div>
  </div>
</template>

<script>
import SpinLoader from 'ç/loaders/spin/Spin.vue';

export default {
  name: 'splash-page',
  components: {
    SpinLoader,
  },
};
</script>

<style scoped lang="scss">
  .revive-splash-page {
    align-items: center;
    background-color: $legacy-primary;
    display: flex;
    flex-direction: column;
    height: 100%;
    justify-content: center;
  }

  .lcu-splash-loader {
    width: 150px;
    position: absolute;
    top: 48%;
    left: 50%;
    transform: translate(-50%, -50%);
  }

  .lcu-splash-logo {
    position: relative;
  }
</style>
